<template>
  <div class="row-details">
    <template v-if="full && address">
      <div :class="{'d-sm-inline-block' : !lineBreak}" class="d-block text-primary">{{ title }}:</div>
      <div class="mb-2 contact-detail-value">
        <div>{{address.street1}}</div>
        <div v-if="address.street2">{{address.street2}}</div>
        <div>{{cityStateZip}}</div>
      </div>
    </template>
    <template v-else>
      <span :class="{'d-sm-inline-block' : !lineBreak}" class="d-block text-primary mr-3">{{ title }}:</span>
      <span class="contact-detail-value">{{addressString}}</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'AddressDetails',
  props: {
    address: {
      type: Object,
      default() {
        return {};
      },
    },
    title: {
      type: String,
      default() {
        return 'Address';
      },
    },
    full: {
      type: Boolean,
      default: false,
    },
    lineBreak: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    addressString() {
      if (!this.address) {
        return '';
      }

      const line2 = this.address.street2 ? `${this.address.street2}, ` : '';
      return `${this.address.street1}, ${line2}${this.cityStateZip}`;
    },
    cityStateZip() {
      const spr = this.address.stateProvinceRegion ? `, ${this.address.stateProvinceRegion}` : '';
      const zipPCP = this.address.zip || this.address.zipPostalcodePostcode || null;
      return `${this.address.city}${spr}${zipPCP ? ` ${zipPCP}` : ''}`;
    },
  },
};
</script>
